import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faArchive } from "@fortawesome/free-solid-svg-icons";

import { IconComponent } from "./types";

export const SomedayIcon: IconComponent = (props) => {
  return <FontAwesomeIcon {...props} icon={faArchive} color="#CAC087" />;
};
